


































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import CommonModalHeader from '@/components/common/CommonModalHeader.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import { vxm } from '@/store';
import { CreateDirectoryDto } from '@/@types/Directory';

@Component({
  components: {
    CommonModalHeader,
    CommonButton
  },
})
export default class AddFolderModal extends Vue {
  @Prop(Boolean) public isAddFolderModal!: boolean;
  private modalHeaderTitle: 'フォルダを追加します' = 'フォルダを追加します';
  private modalMode: string = 'add';
  private items: Array<'要件定義' | '画面設計書' | '画面フロー'> = ['要件定義', '画面設計書', '画面フロー'];
  private addButtonColor: 'light-blue' = 'light-blue';
  private addButtonElevation: string = '0';
  private canselButtonColor: 'blue-grey lighten-5' = 'blue-grey lighten-5';
  private cancelButtonElevation: string = '0';
  private directoryName: string = '';

  private async onCreateDirectory() {
    const accountId = vxm.theoryApi.authStore.getCurrentUserInfo?.results.accountId;
    if (accountId) {
      const params: CreateDirectoryDto = {
        projectId: this.projectId,
        accountId: accountId,
        directoryName: this.directoryName,
        parentDirectoryId: this.currentDirectoryId,
      };
      await vxm.theoryApi.directoriesStore.createDirectory(params);
    }
    await vxm.theoryApi.directoriesStore.fetchDirectoriesAndFiles({
      'project-id': this.projectId,
      'sort': 'name',
      'order': 'asc',
    });
    this.closeAddFolderModal();
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId!;
  }

  get currentDirectoryId() {
    const response = vxm.theoryApi.directoriesStore.getCurrentDirectory;
    if (response) {
      return response.directoryId;
    } else return null;
  }

  @Emit('closeAddFolderModal')
  private closeAddFolderModal(): void {
    return;
  }
}
